$(function () {

	$('a[href^="#"]').click(function(){
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top;
	 	$("html, body").animate({scrollTop:position}, 550, "swing");
	    return false;
	});
  
    var swiper = new Swiper(".ranking_top_slide", {
      slidesPerView: "auto",
      grabCursor: true,
      navigation: {
        nextEl: ".ranking_top .swiper-button-next",
        prevEl: ".ranking_top .swiper-button-prev",
      },
    });
    var swiper2 = new Swiper(".ranking_bottom_slide", {
      slidesPerView: "auto",
      grabCursor: true,
    });

});
